export default {
      id: "playback__warn-event-usage",
      viewBox: "0 0 14 18",
      url: __webpack_public_path__ + "img/icons.svg#playback__warn-event",
      toString: function () {
        return this.url;
      }
    }